export function getCSRFToken() {
  const inputs = document.getElementsByName('__RequestVerificationToken');

  if (inputs && inputs[0]) {
    return inputs[0].value;
  }
  return '';
}

